import { useEffect, useRef } from 'react';
import AuthLayout from '../layouts/AuthLayout';
import { Box, IconButton, Input, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import Header from '../userfiles/components/Header';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import BoltIcon from '@mui/icons-material/Bolt';
import QuickTurnTable from './components/QuickTurnTable';
import RejectQuickTurnPopup from './components/RejectQuickTurnPopup';
import usePendingQuickTurnActions from './usePendingQuickTurnActions';

const PendingQuickTurn = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const {
    getQuickTurnRequests,
    loadNextPage,
    acceptQuickTurnRequest,
    rejectQuickTurnRequest,
    requests,
    isLoading,
    actionLoading,
    hasNextPage,
  } = usePendingQuickTurnActions();

  const [rejectTarget, setRejectTarget] = useState(null); // request being rejected, or null
  const debounceRef = useRef(null);

  useEffect(() => {
    getQuickTurnRequests();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      getQuickTurnRequests({ query: value || undefined });
    }, 600);
  };

  return (
    <AuthLayout sx={{ padding: '2.1% 3.4% 2.1% 3.4%' }}>
      <Header />
      <Box px={{ xs: 1.5, sm: 2, md: 3 }} pr={{ xs: 1.5, sm: 3, md: 6 }} className='flex col' mt={4}>

        <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', color: 'black', mb: 2 }} gap={1}>
          <KeyboardBackspaceOutlinedIcon onClick={() => navigate(-1)} sx={{ color: 'black', cursor: 'pointer' }} />
          <Typography sx={{ fontFamily: 'Rubik', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '14px', xl: '20px' } }}>
            Back
          </Typography>
        </Box>

        <Box className='flex j-between' mb={3}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'center' }, justifyContent: 'space-between', gap: { xs: 1.5, md: 4 }, width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <BoltIcon sx={{ fontSize: { xs: '18px', md: '22px', lg: '26px', xl: '36px' }, color: '#f59e0b' }} />
              <Box>
                <Typography sx={{ color: '#000000', fontFamily: 'Rubik', fontWeight: 600, fontSize: { xs: '16px', md: '18px', lg: '20px', xl: '30px' } }}>
                  Quick Turn Requests
                </Typography>
                <Typography sx={{ color: '#000000', fontFamily: 'Rubik', fontSize: { xs: '11px', md: '12px', lg: '13px', xl: '20px' } }}>
                  Pending quick turn video requests awaiting assignment.
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'stretch', sm: 'center' }, justifyContent: 'end', gap: { xs: 1, sm: 2 }, width: { xs: '100%', md: 'auto' } }}>
              <Box id="search">
                <Input
                  value={searchTerm}
                  onChange={handleSearch}
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    width: { xs: '100%', sm: 'auto' },
                    borderBottom: 2,
                    borderColor: '#333333',
                    input: {
                      fontSize: { xs: '12px', md: '13px', lg: '14px', xl: '20px' },
                      fontWeight: 400,
                      color: '#000000',
                    },
                  }}
                  placeholder="Search"
                  startAdornment={
                    <IconButton sx={{ paddingBottom: 1, fontSize: { xs: '12px', md: '14px', lg: '17px', xl: '24px' }, '& .MuiSvgIcon-root': { fontSize: { xs: '12px', md: '14px', lg: '17px', xl: '24px' } }, paddingRight: 2 }}>
                      <SearchIcon style={{ color: '#000000' }} />
                    </IconButton>
                  }
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <QuickTurnTable
          requests={requests}
          isLoading={isLoading}
          actionLoading={actionLoading}
          hasNextPage={hasNextPage}
          onLoadMore={loadNextPage}
          onAccept={(id) => acceptQuickTurnRequest(id)}
          onReject={(id) => setRejectTarget(requests.find((r) => r.id === id) || { id })}
        />

        <RejectQuickTurnPopup
          open={!!rejectTarget}
          request={rejectTarget}
          isSubmitting={rejectTarget && actionLoading === rejectTarget.id}
          onClose={() => setRejectTarget(null)}
          onSubmit={(rejectionNote) =>
            rejectQuickTurnRequest(rejectTarget.id, rejectionNote, () => {
              setRejectTarget(null);
            })
          }
        />

      </Box>
    </AuthLayout>
  );
};

export default PendingQuickTurn;
